import { useTranslation } from 'react-i18next'
import CommunicationBoardContent from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardContent'
import useCommunicationBoardData from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/useCommunicationBoardData'
import useCommunicationBoardEventListener from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/useCommunicationBoardEventListener'

const CommunicationBoard = () => {
  const { t } = useTranslation()
  useCommunicationBoardEventListener()
  const { messages, updatedAt, error, folded } = useCommunicationBoardData()

  return <CommunicationBoardContent t={t} messages={messages} updatedAt={updatedAt} error={error} folded={folded} />
}

export default CommunicationBoard
